import React, { Component } from 'react'
import { connect } from 'react-redux'
import { RouteKey } from '@internal/route'
import { ELazyStatus } from '@lib/ReduxBase'
import { CreateHocLazy } from '@lib/ReduxBase'
import { DeliveryShared, MediaShared } from '@shared/Pages'
import { Box } from '@mui/material'
import { CreateRoutePath } from '@lib/RouteBase'
import UIStyleds, { IBreadcrumbConfig } from '@shared/UIStyleds'
import { ISelectMultipleOption } from '@lib/Forms/Inputs'
import { MediaMapping } from '@internal/services/MediaService'
import { EMediaDeliveryContentType, EMediaDeliveryStatus, IMedia, IMediaDelivery } from '@shared/Types'
import { ApiAlertContext, GlobalModal, IGlobalModalContext, MapGlobalModalContext } from '@lib/ApiContext'
import { MediaActionPannel, MediaBtnLinks, MediaBtnUpload, MediaBtnUploadNote } from '@shared/Pages/Media'
import ContentPreview, { IItemInfo } from '@lib/Component/ContentPreview'
import UploadLayout, { IUploadLayoutContext, UploadLayoutContext } from '@lib/Layout/UploadLayout2'
import UploadService from '@shared/Services/UploadService'
import { GetTable } from './configs'
import { TProgressItemUpload } from './types'
import { FormDelete, FormEdit } from './forms'
import { IMediaReduxProps } from './redux.types'
import { mapDispatchToProps, mapStateToProps } from './redux.map'

const TableInstance = GetTable()

interface IProps extends IMediaReduxProps {}
export default class MediaPage extends Component<IProps> {
  refUploadLayout: UploadLayout | null = null
  refPreview: ContentPreview | null = null

  componentWillUnmount(): void {
    this.props.clean()
  }

  render() {
    return (
      <UIStyleds.WrapProfile>
        <UploadLayout ref={(ref) => (this.refUploadLayout = ref)} UploadExecutor={this.handleUploadExecutor}>
          <ContentPreview ref={(ref) => (this.refPreview = ref)} />
          {this.renderInfoBar()}
          <TableInstance
            ActionPannel={(x) => {
              const data = x.data as IMedia
              return (
                <MediaActionPannel
                  Delete={<FormDelete data={data} onSubmit={(x) => this.props.CRUD.Delete(data.Id, x)} />}
                  Edit={<FormEdit data={data} onSubmit={(x) => this.props.CRUD.Update(data.Id, x)} />}
                  onPreview={() => this.onPreview(data)}
                />
              )
            }}
            ReduxOption={this.props.tableInfo}
            onChange={this.props.onChangeTableInfo}
          />
        </UploadLayout>
      </UIStyleds.WrapProfile>
    )
  }

  renderInfoBar = () => {
    const deliveryStatus = this.props.slice.delivery?.Status
    const isUpload = this.props.status === ELazyStatus.Loaded
    const isDisabled = deliveryStatus !== EMediaDeliveryStatus.Pending
    return (
      <GlobalModal>
        <MediaShared.TopBar value={this.props.slice.delivery} breadcrumbConfig={this.getBreadcrumbConfigs()}>
          <Box sx={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'flex-end' }}>
            {MapGlobalModalContext((context) => (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '9px', ml: '10px' }}>
                {this.renderLinksModalBtn(context, this.props.slice.delivery)}
                <MediaBtnUpload onClick={isUpload && !isDisabled ? () => this.onUpload(context) : undefined} disabled={isDisabled} />
                <MediaBtnUploadNote />
              </Box>
            ))}
          </Box>
        </MediaShared.TopBar>
      </GlobalModal>
    )
  }

  renderLinksModalBtn = (context: IGlobalModalContext, data?: Partial<IMediaDelivery>) => {
    if (data?.ContentType !== EMediaDeliveryContentType.Url) return <></>
    return (
      <MediaBtnLinks
        onClick={() => {
          context.ShowModal({ backdropActivated: true, ContentModal: () => <DeliveryShared.FormPreviewUrlType data={data} /> })
        }}
      />
    )
  }

  onUpload = ({ ShowModal, CloseModal }: IGlobalModalContext) => {
    ShowModal({
      backdropActivated: true,
      ContentModal: () => {
        return (
          <UploadLayoutContext.Consumer>
            {(context) => (
              <MediaShared.FormUpload
                categories={this.props.categories}
                onSubmit={(value) => this.handleSubmitUpload(context, value, CloseModal)}
                // fetchUsers={SelectService.fetchUsers}
              />
            )}
          </UploadLayoutContext.Consumer>
        )
      }
    })
  }

  onPreview = (value: IMedia) => {
    this.refPreview?.handleClickOpen({
      DriveFileId: value.ResourceId,
      DateCreated: '',
      Extension: value.Extension,
      Id: value.Id.toString(),
      Name: value.Name
    } as IItemInfo)
  }

  handleSubmitUpload = async (context: IUploadLayoutContext, value: Partial<MediaShared.IFormSubmitModelReponse>, close: () => void) => {
    let date = new Date().getTime()
    const { files = [], ...model } = value
    const temps: TProgressItemUpload[] = []
    files.forEach((e) => temps.push({ File: e, Id: date++, Name: e.name, Status: 'Pending', Other: model }))
    context.addItems(temps)
    context.Show()
    close()
  }

  handleUploadExecutor = async (processItem: TProgressItemUpload, progress: (value: number) => void) => {
    try {
      const fileType = MediaShared.FileHandler.getFileType(processItem)
      if (!fileType) {
        ApiAlertContext.ApiAlert?.PushWarning('Unsupported file format!')
        processItem.message = 'Unsupported file format!'
        throw new Error('Unsupported file format!')
      }
      const extendFile = await MediaShared.FileHandler.getExtendFile(processItem)
      const fileName = processItem.File.name
      const checkExist = await UploadService.CheckExistUploadName(fileName)
      if (!!checkExist) {
        processItem.message = 'Filename already exists!'
        throw new Error('Filename already exists!')
      }
      const bodyRequest = { file: processItem.File, FileType: fileType }
      const uploadResult = await UploadService.uploadRequest(bodyRequest, progress, processItem.Signal?.signal)
      if (!uploadResult) {
        processItem.message = 'Upload failed!'
        throw new Error('Upload failed!')
      }

      const userId = processItem.Other?.UserId
      const categoryIds = this.getCategoryIds(processItem.Other?.Categories)
      this.props.CRUD.Create(MediaMapping.mediaCreateParam({ processItem, extendFile, uploadResult, fileType, userId, categoryIds }))
    } catch (error) {
      console.log(error)
      throw error
    }
  }

  getCategoryIds = (value?: string): string[] => {
    try {
      if (!value) return []
      const list: ISelectMultipleOption[] = JSON.parse(value)
      return list.map((x) => x.Id.toString())
    } catch (error) {
      return []
    }
  }

  getBreadcrumbConfigs = (): IBreadcrumbConfig[] => {
    const info = this.props.slice.delivery
    let label = info?.Name || info?.Title || info?.Description || 'No name'
    if (this.props.slice.status === ELazyStatus.Loading) label = 'Loading...'
    return [{ label: 'Deliveries', url: CreateRoutePath([RouteKey.Profile, RouteKey.Delivery]) }, { label: label }]
  }
}

export { fetchMediaThunk } from './redux.thunks'
export { default as MediaSlice } from './redux.slice'

const HocLazyInstance = CreateHocLazy(MediaPage)
export const MediaMapRedux = connect(mapStateToProps, mapDispatchToProps)(HocLazyInstance)

// export const DeliveryDetail: React.FC = () => (
//   <LayoutModalRoute.Wrapper
//     size='xl'
//     title='Delivery detail'
//     back={RouteKey.Delivery}
//     // slots={{ topBarRight: LayoutMakeupInstance.GetMakeup('DeliveryDetail') }}
//   >
//     <MediaMapRedux />
//   </LayoutModalRoute.Wrapper>
// )
